import { useRef } from 'react';

import { datadogLogger } from './datadogLogger';
import { DDComponent } from './setup';
import { formatErrorLog } from './utils';

export const useLogError = (error: any, component: DDComponent, customData?: Object) => {
    const loggedErrorRef = useRef(null);
    if (!loggedErrorRef.current && !!error) {
        loggedErrorRef.current = error;
        const { message, ...errorContext } = formatErrorLog(error);

        const datadogLogs = datadogLogger();
        datadogLogs.warn(message, {
            ...errorContext,
            component,
            ...customData,
        });
    }
};

export const useLogErrorEshop = (error: any) => useLogError(error, DDComponent.Eshop);
export const useLogErrorSelfService = (error: any) => useLogError(error, DDComponent.SelfService);
export const useLogErrorPayment = (error: any) => useLogError(error, DDComponent.Payment);
export const useLogErrorPublicWeb = (error: any) => useLogError(error, DDComponent.PublicWeb);
